export default "__VITE_ASSET__D2h5DcNL__"